import { IoCheckmarkCircle, IoWarning } from "react-icons/io5";
import styles from "./CustomAlert.module.css";

function getMessageText(message) {
  if (typeof message === "string") return message;
  if (Array.isArray(message)) {
    return message.filter(Boolean).join("\n");
  }
  return "";
}

export default function CustomAlert({
  show,
  onHide,
  title = "Oops!",
  message,
  type,
}) {
  if (!show) return null;

  const titleText = String(title || "");
  const messageText = getMessageText(message);

  // Auto-detect success if type isn't explicitly passed
  const isSuccess =
    type === "success" ||
    (!type &&
      (titleText.toLowerCase().includes("submitted") ||
        titleText.toLowerCase().includes("success") ||
        titleText.toLowerCase().includes("subscribed") ||
        titleText.toLowerCase().includes("otp sent") ||
        messageText.toLowerCase().includes("success")));

  const messageContent = Array.isArray(message) ? (
    <ul className={styles.messageList}>
      {message.filter(Boolean).map((item, index) => (
        <li key={`${index}-${item}`}>{item}</li>
      ))}
    </ul>
  ) : (
    message
  );

  return (
    <div className={styles.root} role="presentation">
      <button
        type="button"
        className={styles.overlay}
        aria-label="Close alert"
        onClick={onHide}
      />
      <div
        className={styles.alertModal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="custom-alert-title"
      >
        <div className={styles.body}>
          <div
            className={`${styles.icon} ${
              isSuccess ? styles.iconSuccess : styles.iconError
            }`}
            aria-hidden="true"
          >
            {isSuccess ? (
              <IoCheckmarkCircle size={52} color="#10B981" />
            ) : (
              <IoWarning size={52} color="#F59E0B" />
            )}
          </div>

          <h4 id="custom-alert-title" className={styles.title}>
            {title}
          </h4>

          <div className={styles.message}>{messageContent}</div>

          <button
            type="button"
            className={`${styles.button} ${
              isSuccess ? styles.btnSuccess : styles.btnError
            }`}
            onClick={onHide}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}